import { NgModule } from '@angular/core';
import { provideRouter, RouterModule, withComponentInputBinding } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconRegistry } from '@angular/material/icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastContainerDirective, ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppComponent } from './app.component';
import { AppRoutes } from './app-routing.routing';
import { HeaderComponent } from './core/header/header.component';
import { FooterComponent } from './core/footer/footer.component';
import { MessagesComponent } from 'commons/messages/messages.component';
import { PipeModule } from 'commons/pipes/pipes.module';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { AuthenticatedHttpService, SpinnerComponent } from 'core';
import { CommonsModule } from 'commons/commons.module';
import { SessionExpiredComponent } from './sessionexpired/session-expired.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule, // required animations module
    RouterModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      preventDuplicates: true,
    }),
    ToastContainerDirective,
    ModalModule,
    BsDropdownModule,
    BsDatepickerModule,
    PipeModule,
    MatProgressSpinnerModule,
    OverlayModule,
    FontAwesomeModule,
    CommonsModule,
    HeaderComponent,
    FooterComponent,
    MessagesComponent,
    NotFoundComponent,
    SessionExpiredComponent,
    SpinnerComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticatedHttpService,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: 'googleTagManagerId', useValue: 'GTM-PJXD44D' },
    provideRouter(AppRoutes, withComponentInputBinding()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry) {
    iconRegistry.setDefaultFontSetClass('material-symbols-outlined', 'mat-ligature-font');
  }
}
